import { Col, Spacer } from "@amzn/stencil-react-components/layout";
import { DetailedRadio } from "@amzn/stencil-react-components/radio";
import { Select } from "@amzn/stencil-react-components/select";
import { Label } from "@amzn/stencil-react-components/text";
import { IItemVersion } from "@/common/types/item.types";
import React from "react";

const RADIO_TO_DROPDOWN_THRESHOLD = 6;

export interface SelectChildSkuProps {
  versions: IItemVersion[];
  selectedVersion?: IItemVersion;
  onChange: (version: IItemVersion) => void;
}

export const SelectChildSku: React.FC<SelectChildSkuProps> = ({ versions, selectedVersion, onChange }) => {
  if (versions.length === 0) return null;

  if (versions.length <= RADIO_TO_DROPDOWN_THRESHOLD) {
    return (
      <Col data-testid="version-selector">
        <Label>Select a version</Label>
        <Spacer height="S300" />
        <Col gridGap="S200">
          {versions.map((version) => (
            <DetailedRadio
              key={version.taxonomyId}
              dataTestId="radio-child-sku"
              titleText={version.displayText}
              checked={selectedVersion?.taxonomyId === version.taxonomyId}
              onChange={() => onChange(version)}
            />
          ))}
        </Col>
      </Col>
    );
  }

  const options = versions.map((v) => v.displayText);
  const handleSelectChange = (selectedValue: string) => {
    const found = versions.find((v) => v.displayText === selectedValue);
    if (found) onChange(found);
  };

  return (
    <Col gridGap="S200" data-testid="version-selector">
      <Label>Select a version</Label>
      <Select
        dataTestId="select-child-sku"
        onChange={handleSelectChange}
        options={options}
        value={selectedVersion?.displayText}
        isSearchable={true}
        width="100%"
      />
    </Col>
  );
};
